import React from 'react'
import Switch from 'react-switch'

interface ToggleSwitchProps {
  checked: boolean
  onChange: (checked: boolean) => void
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ checked, onChange }) => {
  const handleChange = (nextChecked: boolean) => {
    onChange(nextChecked)
  }

  return (
    <Switch
      onChange={handleChange}
      checked={checked}
      onColor="#6F5E4D"
      offColor="#B5A79F"
      offHandleColor="#FFFFFF"
      onHandleColor="#FFFFFF"
      handleDiameter={26}
      uncheckedIcon={false}
      checkedIcon={false}
      height={30}
      width={50}
      className="react-switch"
      activeBoxShadow="0 0 2px 3px rgba(71, 36, 16, 0.2)"
      boxShadow="0 0 2px 3px rgba(0, 0, 0, 0.1)"
    />
  )
}

export default ToggleSwitch
